import React, { Fragment } from "react";
import { CSSTransition } from "react-transition-group";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Modal from "../../../../shared/Modal/Modal";

import { validateCPF } from "../../../../../js/shared/validation-utils";
import {
	setDataToStore,
	onSearchByCPF,
	onInviteParticipant,
	onCloseInviteParticipant,
	ifRenderModalInvalidCPF
} from "../../../actions/advanced-management";
import AdvancedManagementCardWithInput from "./AdvancedManagementCardWithInput";
import AdvancedManagementAboutIndication from "./AdvancedManagementAboutIndication";
import Input from "../../../../shared/Input/Input";
import Callout from "../../../../shared/Callout/Callout";
import Button from "../../../../shared/button/button";
import Loading from "../../../../shared/Loading/Loading";
import InputSearch from "../../../../shared/InputSearch/InputSearch";
import Checkbox from "../../../../shared/Checkbox/Checkbox";
import { isMobile } from "../../../../../js/components/searchform/utils/common";
import { scrollToComponent } from "../../../shared/utils";
import { publish } from "pubsub-js";
import eventType from "../../../events/eventType";
import { ACCOUNT_FAMILY_EVENT } from "../../../events/ga/events";
import { MULTICONTA_INVITATION_EXPIRATION_DAYS } from "../../../../../js/shared/constants";

class AdvancedManagementIndicateUser extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			// ifRenderModalInvalidCPF: false,
			alreadyOpenedModalInvalidCpf: false,
			isDisableSearchButton: true,
			ifRenderModalIndicationSent: false,
			term: false,
			openModalInvalidCPF: false
		};
	}

	onChangeCPFField = (raw, event) => {
		if (event.length === 14 && validateCPF(event)) {
			this.setState({
				isDisableSearchButton: false
			});
		} else {
			this.setState({
				isDisableSearchButton: true
			});
		}

		this.props.setDataToStore({ cpf: event });
	};

	onRenderModalInvalidCPF = () => {
		if (this.props.renderModalInvalidCPF && !this.state.openModalInvalidCPF) {
			this.setState({
				openModalInvalidCPF: true
			});
		} else {
			this.setState({
				openModalInvalidCPF: false
			});
		}
	};

	onInviteParticipant = (cpfParticipant) => {
		this.props.onInviteParticipant({ cpf: cpfParticipant });
	};

	onRenderModalIndicationSent = () => {
		this.props.onCloseInviteParticipant();
		this.setState({
			ifRenderModalIndicationSent: false
		});
		this.props.onRender();

		publish(eventType.ACCOUNT_FAMILY, {
			type: ACCOUNT_FAMILY_EVENT.button_send_success
		})
	};

	componentWillUpdate(nextProps) {
		if (nextProps.isInvitationSuccess && !this.state.ifRenderModalIndicationSent) {
			this.setState(state => ({
				ifRenderModalIndicationSent: true
			}));
		}
	}

	renderCheckbox() {
		const { dataParticipantIndication } = this.props;
		const hasParticipant = Object.keys(dataParticipantIndication).length > 0;

		return (
			<CSSTransition
				in={hasParticipant}
				unmountOnExit
				timeout={1000}
				classNames="advanced-management-indicate-user"
			>
				<Checkbox
					id="term"
					name="term"
					onChange={options => this.setState({ term: options[0].checked })}
					options={[
						{
							label: (
								<span>
									Li e estou de acordo com as{" "}
									<a className="term-link" onClick={() => {
										this.props.onRenderModalTerms();
										publish(eventType.ACCOUNT_FAMILY, {
											type: ACCOUNT_FAMILY_EVENT.button_rule
										})
									}}>
										<strong>regras de utilização</strong>
									</a>{" "}
									do Conta Família.
								</span>
							),
							name: "term",
							checked: this.state.term
						}
					]}
				/>
			</CSSTransition>
		);
	}

	render() {
		const {
			ifRenderModalIndicationSent,
			isDisableSearchButton,
			// ifRenderModalInvalidCPF,
			term,
			openModalInvalidCPF
		} = this.state;

		const {
			ifShow,
			dataToSend,
			onSearchByCPF,
			isLoading,
			isInvalidCPF,
			isFailureLimitReached,
			dataParticipantIndication,
			dataRelationship,
			onRender,
			onCancel,
			ifRenderModalInvalidCPF,
			renderModalInvalidCPF,
			isOneLessAttempt
		} = this.props;

		const hasParticipant = Object.keys(dataParticipantIndication).length > 0;
		const hasRelationship = dataRelationship.length > 0;

		return (
			<Fragment>
				<CSSTransition
					in={ifShow}
					unmountOnExit
					timeout={1000}
					classNames="advanced-management-indicate-user"
				>
					<AdvancedManagementCardWithInput
						hasAuxText={hasParticipant}
						hasAnyCallout={isFailureLimitReached || isInvalidCPF}
						onNext={() => this.onInviteParticipant(dataToSend.cpf)}
						onCancel={hasRelationship ? onRender : onCancel}
						isDisabled={!hasParticipant || !term}
						isLoading={isLoading.onInviteParticipant}
						content={
							<Fragment>
								<h4>Indicação de participante</h4>
								<p>
									Informe o <strong>CPF</strong> do participante que você gostaria de indicar para
									se vincular a você.
								</p>
								<p>
									Vale lembrar que a pessoa indicada precisa estar{" "}
									<strong>cadastrada na MaxMilhas</strong> e ser maior de idade.
								</p>
							</Fragment>
						}
						input={
							<Fragment>
								{window.screen.availWidth > 468 ? (
									<>
										<Input
											onClick={isMobile() && (() => scrollToComponent(".participant-cpf"))}
											className="participant-cpf"
											onChange={this.onChangeCPFField}
											onFocus={this.onRenderModalInvalidCPF}
											value={dataToSend.cpf}
											pattern="\d*"
											inputMode="numeric"
											label="CPF do participante"
											name="cpf"
											disabled={isFailureLimitReached}
											hasError={isInvalidCPF}
											maskpattern={"999.999.999-99"}
										/>
										<Button
											disabled={
												isLoading.onSearchByCPF || isFailureLimitReached || isDisableSearchButton
											}
											onClick={() => {
												onSearchByCPF(dataToSend.cpf, dataRelationship.length);
												publish(eventType.ACCOUNT_FAMILY, {
													type: ACCOUNT_FAMILY_EVENT.button_search_cpf
												})
											}}
											className={`btn btn-primary${isLoading.onSearchByCPF ? " is-loading" : ""
												}`}
										>
											{isLoading.onSearchByCPF ? <Loading width="20px" height="20px" /> : "Buscar"}
										</Button>
									</>
								) : (
									<>
										<InputSearch
											onClick={isMobile() && (() => scrollToComponent(".participant-cpf"))}
											className="participant-cpf"
											onChange={this.onChangeCPFField}
											onFocus={this.onRenderModalInvalidCPF}
											value={dataToSend.cpf}
											pattern="\d*"
											inputMode="numeric"
											label="CPF do participante"
											name="cpf"
											disabled={isFailureLimitReached}
											hasError={isInvalidCPF}
											maskpattern={"999.999.999-99"}
											onSearch={() => onSearchByCPF(dataToSend.cpf, dataRelationship.length)}
											isDisabled={
												isLoading.onSearchByCPF || isFailureLimitReached || isDisableSearchButton
											}
										/>
									</>
								)}
							</Fragment>
						}
						dataAuxText={
							<AdvancedManagementAboutIndication
								name={dataParticipantIndication.name}
								city={dataParticipantIndication.city}
							/>
						}
						callouts={
							<>
								<Callout
									show={isInvalidCPF && !isOneLessAttempt}
									warn
									text={
										<span>
											<strong>CPF não encontrado ou inválido.</strong> Você só tem mais duas
											tentativa hoje. Digite novamente com atenção.
										</span>
									}
								/>
								<Callout
									show={isInvalidCPF && isOneLessAttempt}
									warn
									text={
										<span>
											<strong>CPF não encontrado ou inválido.</strong> Você só tem mais uma
											tentativa hoje. Digite novamente com atenção.
										</span>
									}
								/>
							</>
						}
						renderCheckbox={this.renderCheckbox()}
					/>
				</CSSTransition>

				<Modal
					show={renderModalInvalidCPF && openModalInvalidCPF}
					fixed
					confirm="Ok, entendi"
					title="Atenção!"
					onConfirm={() => ifRenderModalInvalidCPF()}
					description={
						<span>
							Você só tem <strong>mais uma tentativa</strong> para digitar um CPF correto ou válido.
							Caso exceda esse número, poderá tentar de novo <strong>amanhã</strong>. Combinado?
						</span>
					}
				/>

				<Modal
					show={ifRenderModalIndicationSent}
					fixed={true}
					confirm="Ok, entendi"
					title="Indicação enviada"
					description={
						<div>
							<p>
								Este participante tem até <strong>{MULTICONTA_INVITATION_EXPIRATION_DAYS}</strong> para
								aprovar ou reprovar sua indicação antes que ela expire.
							</p>
							<p>Após esse prazo, você poderá indicar este participante novamente.</p>
						</div>
					}
					onConfirm={this.onRenderModalIndicationSent}
				/>
			</Fragment>
		);
	}
}

const mapStateToProps = state => ({
	...state.advancedManagement
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			setDataToStore,
			onSearchByCPF,
			onInviteParticipant,
			onCloseInviteParticipant,
			ifRenderModalInvalidCPF
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedManagementIndicateUser);
